import { styled } from '@fluentui/react';
import { BulkUploadBase } from './bulkUpload.base';
import { getStyles } from './bulkUpload.styles';
import { IBulkUploadProps, IBulkUploadStyleProps, IBulkUploadStyles } from './bulkUpload.types';

export const BulkUpload = styled<IBulkUploadProps, IBulkUploadStyleProps, IBulkUploadStyles>(BulkUploadBase, getStyles, undefined, {
  scope: 'BulkUpload',
});
